import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { EquipamentoDocumentoParams } from '@core/models';
import { isActive } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class DocumentEquipamentosService {
  private readonly endpoint = '/api/Documento/Equipamento';

  constructor( private readonly apiService: ApiService,) {}

  gerarDocumento( params: EquipamentoDocumentoParams,): Observable<Blob> {

    let httpParams = new HttpParams();

    if (params.PeriodoEnum !== undefined && params.PeriodoEnum !== null) {
      httpParams = httpParams.set(
        'PeriodoEnum',
        params.PeriodoEnum.toString()
      );
    }

    if (params.formatoDocumento !== undefined && params.formatoDocumento !== null) {
      httpParams = httpParams.set(
        'formatoDocumento',
        params.formatoDocumento.toString()
      );
    }

    if(params.CategoriaEquipamentoId !== undefined && params.CategoriaEquipamentoId !== null){
      httpParams = httpParams.set('CategoriaEquipamentoId', params.CategoriaEquipamentoId.toString());
    }

    if (params.TipoEquipamentoId !== undefined && params.TipoEquipamentoId !== null){
      httpParams = httpParams.set('TipoEquipamentoId', params.TipoEquipamentoId.toString());
    }

    if (params.DataInicioDe) {
      httpParams = httpParams.set(
        'DataInicioDe',
        params.DataInicioDe
      );
    }

    if (params.DataInicioAte) {
      httpParams = httpParams.set(
        'DataInicioAte',
        params.DataInicioAte
      );
    }

    if ( params.ClienteId !== undefined && params.ClienteId !== null) {
      httpParams = httpParams.set(
        'ClienteId',
        params.ClienteId.toString()
      );
    }

    if (params.PostoId !== undefined && params.PostoId !== null) {
      httpParams = httpParams.set(
        'PostoId',
        params.PostoId.toString()
      );
    }

    return this.apiService.get<Blob>(
      this.endpoint,
      httpParams,
      {
        responseType: 'blob'
      }
    );
  }
}